export default "__VITE_ASSET__IYTv$_xt__"